const TITLE_POSTFIX = ' - FuPa';

export {TITLE_POSTFIX};
